import React from "react";
import styles from "../../styles/screens/PrasadBox/PrasadBox.module.css";
//import Vrindavan_PB from "../../assets/prasadbox/Prasadboxherobanner.jpeg";
//import Ayodhya_PB from "../../assets/prasad_gift/Ayodhya_PB.png";
import krishna from "../../assets/prasadbox/krishnasolo.png";
import { useNavigate } from "react-router-dom";
const PBoxHero = ({ productId }) => {
  //const backgroundImage = productId === "vrindavan-prasad-box" ? Vrindavan_PB : Ayodhya_PB;
  const title = productId === "vrindavan-prasad-box" ? "Vrindavan" : "Ayodhya";
  const navigate = useNavigate();
  const navigateToProductCheckout = () => {
    navigate("/dharmikx/checkout/" + productId);
  };

  return (
    <div className={styles.perfumeBanner}>
      <div className={styles.bannerContainer}>
        
      <div className={styles.bannerLeft}>
          <img
            src={krishna}
            alt="vrindavan krishna"
            className={styles.bottleImage}
          />
        </div>

      <div className={styles.bannerRight}>
            <h1 className={styles.bannerTitle}>
          {title}
          <br />
          Prasad Box
        </h1>
          <div className={styles.bannerDetails}>
            <p className={styles.bannerSubtitle}>
                  <span className={styles.divider}>
                    Blessings wrapped in love and light,{" "}
                  </span>
                </p>
                <p className={styles.bannerDescription}>
                  <span className={styles.divider}>
                    From Shri Banke Bihari's feet to Krishn'a divine {" "}
                  </span>
                </p>
          </div>
          <button className={styles.orderButton} onClick={navigateToProductCheckout}>ORDER NOW</button>
        </div>
    </div>
    </div>
  );
};

export default PBoxHero;
